
import { ref } from 'vue';
import { computed, defineComponent } from '@vue/runtime-core';

export default defineComponent({
  name: 'SearchAndAdd',
  props: {isAlreadyExists:Boolean},
	emits: ['addTodo', 'searchChange'],
  setup (props,{emit}) {
    const newTodo = ref(''); 
    const upHere=ref(false);
    const addTodo=()=>{
      if(!props.isAlreadyExists){
        emit("addTodo",newTodo.value);
        newTodo.value='';
      }
		}
    const searchChange=()=>{
			emit("searchChange",newTodo.value)
		}
    const cancelTodo=()=>{
      newTodo.value='';
      emit("searchChange",newTodo.value)
    }
    const isShow=computed(()=>{
      if(newTodo.value){
        upHere.value=true;
      } else {
        upHere.value=false;
      }
      return upHere.value;
    })
    return {
      isShow,
      newTodo,
			addTodo,
      cancelTodo,
      searchChange
    }
  }
})
